import { render, staticRenderFns } from "./icyButton.vue?vue&type=template&id=68c2f19a&scoped=true&"
import script from "./icyButton.vue?vue&type=script&lang=js&"
export * from "./icyButton.vue?vue&type=script&lang=js&"
import style0 from "./icyButton.vue?vue&type=style&index=0&id=68c2f19a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c2f19a",
  null
  
)

export default component.exports